import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const stockBalanceService = { getAllStockBalances, getStockBalanceByItem }

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.location) params.location = filter.location
  filter?.searchArray?.forEach((w, i) => {
    if (w !== null && w !== '') params[`search_words[${i}]`] = w
  })
  return params
}

export function getAllStockBalances(filter) {
  return apiHelper(API_URL).get('/stock-balances', { params: buildParams(filter) })
}
export function getStockBalanceByItem(itemCode) {
  return apiHelper(API_URL).get(`/stock-balances/${itemCode}`)
}
